import API from '../../../Utils/api';

import styles from './InfoAthleteModal.module.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { useUser } from '../../../Context/useUser';
import Avatar from 'react-avatar';
import { FaEnvelope, FaCalendar, FaEye, FaTrash, FaCheck } from 'react-icons/fa';

export default function InfoAthleteModal({ onClose, relationship }) {
    const navigate = useNavigate();

    const { user } = useUser();

    const acceptAthlete = async () => {
        try {
            await API.approveRelationshipById(relationship._id);
            onClose?.();
            toast.success('OK', {
                position: 'bottom-center'
            });
        } catch (error) {
            toast.error(error?.response?.data?.error, {
                position: 'bottom-center'
            });
        }
    };

    const removeAthlete = async () => {
        try {
            await API.deleteRelationshipById(relationship._id);
            onClose?.();
            toast.success('OK', {
                position: 'bottom-center'
            });
        } catch (error) {
            toast.error(error?.response?.data?.error, {
                position: 'bottom-center'
            });
        }
    };

    return (
        <div className={styles.modalContent}>
            <div className={styles.athleteHeader}>
                <Avatar
                    name={`${relationship.athlete.firstName} ${relationship.athlete.lastName}`}
                    size='80'
                    round={true}
                    className={styles.avatar}
                />
                <div className={styles.athleteInfo}>
                    <h3 className={styles.athleteName}>
                        {relationship.athlete.firstName} {relationship.athlete.lastName}
                    </h3>
                    <span className={styles.statusBadge} data-status={relationship.status.toLowerCase()}>
                        {relationship.status}
                    </span>
                </div>
            </div>

            <div className={styles.detailsSection}>
                <div className={styles.detailItem}>
                    <FaEnvelope className={styles.detailIcon} />
                    <div>
                        <div className={styles.detailLabel}>Email</div>
                        <div className={styles.detailValue}>{relationship.athlete.email}</div>
                    </div>
                </div>
                <div className={styles.detailItem}>
                    <FaCalendar className={styles.detailIcon} />
                    <div>
                        <div className={styles.detailLabel}>Coaching Since</div>
                        <div className={styles.detailValue}>
                            {new Date(relationship.updatedAt).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.actions}>
                {relationship.status === 'Active' ? (
                    <button
                        className={styles.primaryBtn}
                        onClick={() => navigate(`/athlete/${relationship.athlete._id}`)}
                    >
                        <FaEye />
                        <span>View Athlete</span>
                    </button>
                ) : relationship.createdBy !== user._id ? (
                    <button className={styles.primaryBtn} onClick={acceptAthlete}>
                        <FaCheck />
                        <span>Accept Athlete</span>
                    </button>
                ) : null}
                <button className={styles.dangerBtn} onClick={removeAthlete}>
                    <FaTrash />
                    <span>Remove Athlete</span>
                </button>
            </div>
        </div>
    );
}
